//Props Validations
import PropTypes from "prop-types";

import { components } from "react-select";
import Avatar from "@mui/material/Avatar";

import { getNameLetter, stringToColor } from "../../../utils/driverAnalysisUtils";
const CustomMultiValueLabel = (props) => {
    return (
        <components.MultiValueLabel {...props}>
            <div
                style={{
                    display: "flex",
                    // margin: "2px 0px",
                    alignContent: "center",
                }}
            >
                <Avatar
                    // key={i}
                    sx={{
                        bgcolor: stringToColor(props.data.label),

                        width: 16,
                        height: 16,
                        fontSize: 8,
                        // zIndex: i + 1,
                    }}
                >
                    {getNameLetter(props.data.label)}
                </Avatar>
                <span
                    style={{
                        fontSize: "10px",
                        marginLeft: "5px",
                    }}
                >
                    {props.data.label}
                </span>
            </div>
        </components.MultiValueLabel>
    );
};

CustomMultiValueLabel.propTypes = {
    props: PropTypes.object,
    data: PropTypes.object,
    label: PropTypes.string,
};

export default CustomMultiValueLabel;
